import React from 'react';
import { 
    Code,
    Heading, 
    Stack,
    useToast,
    VStack,
} from '@chakra-ui/react';

import { TextoInicioCalculadora } from '../components/calculadoras/TextoInicioCalculadora';
import SensacionTermica from '../components/calculadoras/SensacionTermica'


export function Calculadoras() {

    const toast = useToast()
    const id = 'calculadoras-toast'

    if (!toast.isActive(id)) {
        toast({ 
        id,
        description: "Voy a crear unas cuantas calculadoras, las subiré a medida que las tenga",
        duration: 10000,
        isClosable: true,
        position: 'down',
        title: 'Sección Calculadoras en construcción',
        status: 'info',
        variant: 'solid'
        })
    }

    return(
        <>
            <VStack 
                // backgroundColor={'gray.700'} 
                mt={10} 
                rounded={'2xl'}
                width='80%' // Fija el ancho a 600px
                maxW='80%' // Asegura que no se expanda más allá de 600px
                minW='80%' // Asegura que no se contraiga menos de 600px
                >
                <Heading>calculadoras</Heading>
                <Stack direction='row'>
                    <Code 
                        mb={'20px'}
                        colorScheme='cyan' 
                        children='Calculadoras creadas' />
                </Stack>
                <TextoInicioCalculadora />
                <SensacionTermica />

            </VStack>
            
        </>
    )
}
